import gql from 'graphql-tag';

export const updateCouponMutation = gql`
  mutation ($input: CouponUpdateInput) {
    updateCoupon(input: $input)
    {
      minisiteId
      application {
        applicationId
      }
      title
      description
      cover {
        mediaId
        url
      }
      date
      price
      remark
      stamps
      javascript
      notificationImage {
        mediaId
        url
      }
    }
  }
`
